import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
import VeltCursorPointerAudioHuddleAvatarWireframe from './VeltCursorPointerAudioHuddleAvatarWireframe/VeltCursorPointerAudioHuddleAvatarWireframe';
import VeltCursorPointerAudioHuddleAudioWireframe from './VeltCursorPointerAudioHuddleAudioWireframe/VeltCursorPointerAudioHuddleAudioWireframe';
var VeltCursorPointerAudioHuddleWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-cursor-pointer-audio-huddle-wireframe", __assign({}, transformedProps), children));
};
VeltCursorPointerAudioHuddleWireframe.Avatar = VeltCursorPointerAudioHuddleAvatarWireframe;
VeltCursorPointerAudioHuddleWireframe.Audio = VeltCursorPointerAudioHuddleAudioWireframe;
export default VeltCursorPointerAudioHuddleWireframe;
